import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";
import styled from "styled-components/native";
import { VDBText } from "..";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";
import { SpaceType } from "../Spacer/types";
import { getWarningColors } from "./utils";
import { WarningMessageProps } from "./types";

const WarningMessage = ({
  type,
  message,
  typographyStyle,
  textColor,
}: WarningMessageProps) => {
  const { theme, typography } = useScreenOptionsHooks();
  const { backgroundColor, iconColor } = getWarningColors(type, theme);

  return (
    <Container backgroundColor={backgroundColor}>
      <VDBIcon
        color={iconColor}
        size={24}
        variant={IconsVariant.VDBCustom}
        name={VDBIcons.WARNING}
      />
      <VDBText
        color={textColor ? textColor : theme["core-05"]}
        style={typography[typographyStyle ? typographyStyle : "Minor-R"]}
        type={{ flex: 1 }}
      >
        {message}
      </VDBText>
    </Container>
  );
};

export default WarningMessage;

const Container = styled.View<{
  backgroundColor: string;
}>`
  flex-direction: row;
  gap: ${SpaceType.Basic}px;
  align-items: center;
  background-color: ${({ backgroundColor }: { backgroundColor: string }) =>
    backgroundColor};
  min-height: 36px;
  padding: ${SpaceType.Basic}px;
  border-radius: ${SpaceType.Basic}px;
`;
